import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HighchartsChartModule } from 'highcharts-angular';
import { NouisliderModule } from 'ng2-nouislider';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
import { JoyrideModule } from 'ngx-joyride';
import { ShareModule } from 'ngx-sharebuttons';
import { FollowedPropertyFilterPipe } from 'src/app/shared/modules/follow-filter/pipes/followed-property-filter.pipe';
import { NumberCommaDirective } from '../../app/_core/access-control/currency.directive';
import { SharedModule } from '../../app/_shared/shared.module';
import { NavigationModule } from '../navigation/navigation.module';
import { PropertyFilterModule } from '../property-filter/property-filter.module';
import { LocalTrendsComponent } from './component/_shared/local-trends/local-trends.component';
import { AreaNotCoveredComponent } from './component/map/area-not-covered/area-not-covered.component';
import { AreaNotCoveredDirective } from './component/map/area-not-covered/area-not-covered.directive';
import { DefaultAreaNotCoveredComponent } from './component/map/area-not-covered/component/default-area-not-covered/default-area-not-covered.component';
import { HomehuntAreaNotCoveredComponent } from './component/map/area-not-covered/component/homehunt-area-not-covered/homehunt-area-not-covered.component';
import { FavoriteWidgetComponent } from './component/map/favorite-widget/favorite-widget.component';
import { MapViewComponent } from './component/map/map-view/map-view.component';
import { PropertyListSheetComponent } from './component/map/property-list-sheet/property-list-sheet.component';
import { ZoomLimitComponent } from './component/map/property-search-error/property-search-error.component';
import { WorkspaceComponent } from './component/workspace/workspace.component';
import { MapService } from './service/map.service';
import { MarkerService } from './service/marker.service';
import { PropertyService } from './service/property.service';
import { PublicRecordService } from './service/public-record.service';
import { SearchService } from './service/search.service';
import { WorkspaceService } from './service/workspace.service';
import { WorkspaceRoutingModule } from './workspace-routing.module';

export const customCurrencyMaskConfig = {
  align: 'left',
  allowNegative: true,
  allowZero: true,
  decimal: '.',
  precision: 0,
  prefix: '',
  suffix: '',
  thousands: ',',
  nullable: true,
  min: 0,
  max: null,
  inputMode: CurrencyMaskInputMode.NATURAL,
};
@NgModule({
  declarations: [
    FavoriteWidgetComponent,
    FollowedPropertyFilterPipe,
    LocalTrendsComponent,
    MapViewComponent,
    PropertyListSheetComponent,
    // SearchComponent,
    // ViewSearchComponent,
    // ViewSearchPipe,
    WorkspaceComponent,
    AreaNotCoveredComponent,
    DefaultAreaNotCoveredComponent,
    AreaNotCoveredDirective,
    HomehuntAreaNotCoveredComponent,
    ZoomLimitComponent,
    NumberCommaDirective,
    // SearchAgentComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HighchartsChartModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatDialogModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTabsModule,
    MatTooltipModule,
    NavigationModule,
    NgbModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NouisliderModule,
    ReactiveFormsModule,
    ScrollingModule,
    SharedModule,
    WorkspaceRoutingModule,
    ShareModule,
    PropertyFilterModule,
    JoyrideModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
  entryComponents: [],
})
export class WorkspaceModule {
  constructor(
    private mapService: MapService,
    private markerService: MarkerService,
    private propertyService: PropertyService,
    private searchService: SearchService,
    private workspaceService: WorkspaceService,
    private publicRecordService: PublicRecordService
  ) { }
}
